import { render, staticRenderFns } from "./SchoolDetailPage.vue?vue&type=template&id=726ea12e&scoped=true&"
import script from "./SchoolDetailPage.vue?vue&type=script&lang=ts&"
export * from "./SchoolDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolDetailPage.vue?vue&type=style&index=0&id=726ea12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ea12e",
  null
  
)

export default component.exports